import { jsx as _jsx } from "preact/jsx-runtime";
import { useContext } from 'preact/hooks';
import { SDKContext } from '../context';
import { openPublisherOfferwall } from '../utils/offerwall';
import { injectMacrosText } from '../utils';
import { createDebugLogger } from '../utils/debug';
const debug = createDebugLogger('OfferwallCTA');
/**
 * Button component for opening the offerwall.
 *
 * Publisher colors flow through CSS custom properties on the button element.
 * Hover state lives in CSS (gated by `@media (hover: hover)`) — no React state
 * or `isMobile` prop is required for styling.
 */
export function OfferwallCTA({ settings, styles, apiPayload, }) {
    const ctx = useContext(SDKContext);
    if (!settings.enable_offerwall || !settings.offerwall_show_cta) {
        return null;
    }
    // Don't render if USP (User Selected Perks) is enabled
    if (settings.enable_user_selected_perks &&
        settings.enable_usp &&
        apiPayload?.pub_user_id) {
        return null;
    }
    const handleOfferwallClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!ctx) {
            debug.error('SDKContext missing');
            return;
        }
        const root = ctx.store.getShadowRoot() ?? document;
        openPublisherOfferwall({
            settings,
            styles,
            apiPayload,
            root,
            fromCloseButton: false,
            isWebView: ctx.sdk.isWebView,
            sendMessage: (name, data) => ctx.sdk.sendMessage(name, data),
            closeModal: () => {
                void ctx.store.closeModal();
            },
        });
    };
    const offerWallBtnStyles = styles.offerwall?.button;
    const backgroundColor = offerWallBtnStyles?.offerwall_mou_button_background ||
        styles.offerText?.buttonNo?.background ||
        '#007bff';
    const textColor = offerWallBtnStyles?.offerwall_mou_button_color ||
        styles.offerText?.buttonNo?.color ||
        '#ffffff';
    const borderColor = offerWallBtnStyles?.offerwall_mou_button_stroke ||
        styles.offerText?.buttonNo?.stroke ||
        backgroundColor;
    const hoverColor = offerWallBtnStyles?.offerwall_mou_button_hover || '#0056b3';
    const borderRadius = offerWallBtnStyles?.offerwall_mou_button_radius ||
        styles.offerText?.offerwall_mou_button_radius ||
        '4';
    const fontSize = styles.offerText?.cta_text_size
        ? `${styles.offerText.cta_text_size}`
        : undefined;
    const fontWeight = styles.offerText?.cta_text_style;
    const fontFamily = styles.offerText?.font;
    const themeVars = {
        '--adpx-offerwall-bg': backgroundColor,
        '--adpx-offerwall-color': textColor,
        '--adpx-offerwall-border': borderColor,
        '--adpx-offerwall-hover-bg': hoverColor,
        '--adpx-offerwall-radius': `${borderRadius}px`,
        ...(fontSize ? { '--adpx-offerwall-font-size': fontSize } : {}),
        ...(fontWeight ? { '--adpx-offerwall-font-weight': fontWeight } : {}),
        ...(fontFamily ? { '--adpx-offerwall-font': fontFamily } : {}),
    };
    return (_jsx("button", { className: 'adpx_offerwall-cta-btn', style: themeVars, onClick: handleOfferwallClick, children: injectMacrosText(settings.offerwall_cta || 'More Offers', apiPayload) }));
}
